// Topology.tsx

import React from 'react'

interface TopologyProps {
  img: string | null
  err: string | null
}

export default function Topology(props: TopologyProps) {

  return (
    <div style={{ marginBottom: '20px' }} className='card card-flush h-md-100'>
      <div
        className='card-body d-flex flex-column justify-content-between mt-9 bgi-no-repeat bgi-size-cover bgi-position-x-center pb-0'
      >
        {props.err !== 'error' ? (
          <>
            <div>
              <div className='fs-2hx f-titulo fs-md text-center text-marino mb-5'>
                <span className='me-2'>
                  CTX-Topology
                  <br />
                </span>
              </div>
            </div>
            <img src='/media/imgv2/franja.png' alt='Franja' />
            {props.img ? (
              <img
                className='mx-auto'
                src={props.img}
                alt='Topology'
                style={{ marginBottom: '20px', height: 'auto', width: '100%' }}
              />
            ) : (
              <p>No topology image available.</p>
            )}
          </>
        ) : (
          <div className='text-center text-danger'>
            <p>Error loading topology image.</p>
          </div>
        )}
      </div>
    </div>
  )
}
